export default __webpack_public_path__ + "static/media/IMG_20211224_221833.6bac908b.png";